import Vue from "vue";
import api from "@/api/reports";

const buscaDadosValoresContrato = (periodoDe, periodoAte, contratoId) => {
  return Vue.api
    .get(api.buscaDadosValoresContrato(periodoDe, periodoAte, contratoId))
    .then(({ data }) => data);
};

const buscaDadosMensalidade = (periodoDe, periodoAte, contratoId) => {
  return Vue.api
    .get(api.buscaDadosMensalidade(periodoDe, periodoAte, contratoId))
    .then(({ data }) => data);
};

const buscaDadosTitular = codigoBeneficiario => {
  return Vue.api
    .get(api.getDadosTitular(codigoBeneficiario))
    .then(({ data }) => data);
};

export { buscaDadosValoresContrato, buscaDadosMensalidade, buscaDadosTitular };
